import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';

import { PostEditorScreen } from '@screens';
import { screens } from './screens';
import type { PostStackParamListType } from './types';
import { Header, WebHeader } from '@components';

const PostStack =
  createNativeStackNavigator<PostStackParamListType>();

export const PostNavigator = observer(() => {
  return (
    <PostStack.Navigator
      screenOptions={{
        headerShown: true,
        header: (props) =>
          Platform.select({
            web: (
              <WebHeader
                activeTabButtonName={screens.HomeTabNavigator}
              />
            ),
            default: <Header {...props} />,
          }),
      }}
    >
      <PostStack.Screen
        component={PostEditorScreen}
        name={screens.PostEditor}
      />
    </PostStack.Navigator>
  );
});
